import { render } from "./TripChimpPage.vue?vue&type=template&id=39cf98f0&scoped=true"
import script from "./TripChimpPage.vue?vue&type=script&lang=ts"
export * from "./TripChimpPage.vue?vue&type=script&lang=ts"

import "./TripChimpPage.vue?vue&type=style&index=0&id=39cf98f0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-39cf98f0"

export default script